import SettingsTabBase from "./SettingsTabBase.jsx";
import SwivuSettingsIncentiveCategoriesContainer from "./SwivuSettingsIncentiveCategoriesContainer.jsx";
import SwivuSettingsIncentiveTagsContainer from "./SwivuSettingsIncentiveTagsContainer.jsx";
import { SETTING_TAB_WIDGET_KEYS } from "../../../other/constants/OtherKeys.jsx";

export default class SwivuSettingsIncentiveCategoriesAndTagsTab extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingsIncentiveCategoriesAndTagsTab";
  }

  static get type() {
    return "swivusettingsincentivecategoriesandtagstab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.incentiveCategoriesAndTagsTab;
  }

  static get configurable() {
    return {
      title: "Categories & Tags",
      cls: "p-[1em]",
      layout: "vbox",
      defaults: {
        labelWidth: "7em"
      },
      items: {
        categoriesContainer: {
          type: SwivuSettingsIncentiveCategoriesContainer.type,
          flex: 1,
          cls: "mb-[1em]"
        },
        tagsContainer: {
          type: SwivuSettingsIncentiveTagsContainer.type,
          flex: 1
        }
      }
    };
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);

    if (otherParams.isFirstShow) {
      const { categoriesContainer, tagsContainer } = this.widgetMap;
      categoriesContainer.loadRecord(record, context, otherParams);
      tagsContainer.loadRecord(record, context, otherParams);
    }
  }

  swivuCheckGrants(user) {
    const { categoriesContainer, tagsContainer } = this.widgetMap;
    categoriesContainer.swivuCheckGrants(user);
    tagsContainer.swivuCheckGrants(user);
  }
}

SwivuSettingsIncentiveCategoriesAndTagsTab.initClass();
